import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const teacherReviewLoginRoute = '/teacher-review/login';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {



  constructor(
    private authService: AuthService,
    private routerService: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | Promise<boolean> | Observable<boolean | UrlTree>  {
    const requiredPermission = route.data.permission;
    return this.authService.appUser$.pipe(
      map(
        user => {
          if (!user) {
            if(requiredPermission === 'teacher') {
              return this.routerService.parseUrl(teacherReviewLoginRoute);
            }
            return this.routerService.createUrlTree([`/sync/login${window.location.pathname}`], {queryParams:route.queryParams});
          }
          return user.role === requiredPermission || this.routerService.parseUrl(teacherReviewLoginRoute);
        }
      )
    );
  }
}
